gsap.registerPlugin(ScrollTrigger);

const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => func.apply(this, args), delay);
    };
};

function HeaderModule() {

    const header = document.querySelector('.site-header');
    const placeholder = document.querySelector('.site-header__placeholder');
    const largeLogo = document.querySelector('.site-header__large-logo');

    if (!header || !placeholder || !largeLogo) return;

    let stInstance = null;
    placeholder.style.height = "200px";
    const updateHeaderPlaceholder = () => {
        window.requestAnimationFrame(() => {
            const headerHeight = header.getBoundingClientRect().height;
            const logoHeight = largeLogo.getBoundingClientRect().height;
            console.log(logoHeight,'logoHeight');
            placeholder.style.height = `${headerHeight + logoHeight}px`;
        });

        console.log(placeholder)
    };

    const initScrollAnimation = () => {
        if (stInstance) stInstance.kill();

        stInstance = gsap.to(largeLogo, {
            height: 0,
            clipPath: 'inset(0 0 100% 0)',
            duration: 0.3,
            ease: 'power2.inOut',
            scrollTrigger: {
                trigger: 'body',
                start: 'top top-=50',
                toggleActions: 'play none none reverse',
                onComplete: updateHeaderPlaceholder,
                onReverseComplete: updateHeaderPlaceholder
            }
        }).scrollTrigger;
    };

    const onResize = debounce(() => {
        updateHeaderPlaceholder();
        initScrollAnimation();
    }, 150);

    // 初始化
    // document.addEventListener('DOMContentLoaded', () => {
        updateHeaderPlaceholder();
        window.requestAnimationFrame(initScrollAnimation);
    // });

    // window.addEventListener('load', updateHeaderPlaceholder);
    window.addEventListener('resize', onResize);

};



function initHeaderModule() {
    const header = document.querySelector('.site-header');
    const placeholder = document.querySelector('.site-header__placeholder');
    const largeLogoContainer = document.querySelector('.site-header__large-logo');

    if (!header || !placeholder || !largeLogoContainer) {
        console.error("必需的 DOM 元素未找到，退出初始化。");
        return;
    }

    let scrollTriggerInstance = null;
    const adjustHeaderPlaceholder = () => {
        const updateHeight = () => {
            const headerHeight = header.getBoundingClientRect().height;
            const logoHeight = largeLogoContainer.getBoundingClientRect().height;
            placeholder.style.height = `${headerHeight + logoHeight}px`;
        };
        window.requestAnimationFrame(updateHeight);
    };

    const initHeaderScrollAnimation = () => {
        if (scrollTriggerInstance) scrollTriggerInstance.kill();

        scrollTriggerInstance = gsap.to(largeLogoContainer, {
            height: 0,
            clipPath: 'inset(0 0 100% 0)',
            duration: 0.3,
            ease: "power2.inOut",
            scrollTrigger: {
                trigger: 'body',
                start: 'top top-=50',
                toggleActions: "play none none reverse",
                onComplete: adjustHeaderPlaceholder,
                onReverseComplete: adjustHeaderPlaceholder
            }
        }).scrollTrigger;
    };

    const handleResize = debounce(() => {
        adjustHeaderPlaceholder();
        initHeaderScrollAnimation();
    }, 150);

    document.addEventListener('DOMContentLoaded', () => {
        adjustHeaderPlaceholder();
        window.requestAnimationFrame(initHeaderScrollAnimation);
    });

    window.addEventListener('load', adjustHeaderPlaceholder);
    window.addEventListener('resize', handleResize);

};



function initSubnavModule() {

    const navLinks = document.querySelectorAll('.site-nav__link');
    let navItems = document.querySelectorAll('.site-nav__item');
    const subnavContainer = $('.subnav');
    const subnavToggles = $('.subnav__toggle');

    if (!navLinks.length || !subnavContainer.length) return;

    const DELAY = 150;
    let hideSubnavTimer = null;
    let activeId = null;
    let isAnimating = false;

    const toggleSubnav = (subnavId,linkIndex) => {
        clearTimeout(hideSubnavTimer);

        if (!subnavId) {
            hideAllSubnavs();
            return;
        }

        if (activeId === subnavId && !isAnimating) return;

        isAnimating = true;
        activeId = subnavId;

        const $target = $(`#${subnavId}`);

        navItems.forEach(item => item.classList.remove('active'));
        navItems[linkIndex].classList.add('active');
        
        subnavToggles.hide().removeClass('active');
        console.log($target)
        $target.fadeIn(50,function(){
            const targetHeight = $('.subnav__inner').outerHeight(true);
            subnavContainer.stop(true, true).animate(
                { height: targetHeight },
                350,
                () => {
                    $target.addClass('active');
                    isAnimating = false;
                }
            );
        });
        
    };

    const hideAllSubnavs = () => {
        activeId = null;
        isAnimating = true;

        subnavToggles.hide().removeClass('active');

        subnavContainer.stop(true, true).animate(
            { height: 0 },
            220,
            () => {
                isAnimating = false;
            }
        );

        navItems.forEach(item => item.classList.remove('active'));

    };

    const delayedHideSubnav = () => {
        hideSubnavTimer = setTimeout(() => toggleSubnav(null), DELAY);
    };

    // ---- 事件绑定 ----
    navLinks.forEach((link, index) => {
        link.addEventListener('mouseenter', e => {
            const id = e.currentTarget.dataset.subnav;
            toggleSubnav(id,index);
        });

        link.addEventListener('mouseleave', delayedHideSubnav);
    });

    $('.subnav').on('mouseenter', () => clearTimeout(hideSubnavTimer));
    $('.subnav').on('mouseleave', delayedHideSubnav);


    $('.subnav__category-link').on('mouseenter', function() {
        const $category = $(this).closest('.subnav__category');
        
        if ($category.hasClass('active')) return;
        
        const index = $category.index();
        const $inners = $category.closest('.subnav__toggle').find('.subnav__category-inner');
        
        $category.addClass('active').siblings().removeClass('active');
        $inners.hide().eq(index).fadeIn(200);
    });

};

function initMobileSubnavModule() {
    $('.mobile-menu__btn').on('click', function(){
        $('.mobile-header__nav').fadeIn(200);
    })

    $('.mobile-header__close').on('click', function(){
        $('.mobile-header__nav').fadeOut(200);
    })

    $('.mobile-header__link').on('click', function(){
        let item = $(this).closest('.mobile-header__item');
        console.log(item);
        item.siblings().removeClass('active');
        item.toggleClass('active');
        item.siblings().find('.mobile-header__submenu').slideUp(200);
        item.find('.mobile-header__submenu').slideToggle(200);
    });
};


function initCommon(){

    const ScrollReveal = {
        defaults: {
            duration: 400,
            delay: 0,
            threshold: 0.1,
            once: true,
            easing: 'ease-out'
        },

        init(options = {}) {
            this.settings = { ...this.defaults, ...options };
            this.elements = document.querySelectorAll('[data-reveal]');
            
            if (!this.elements.length) return;

            this.observer = new IntersectionObserver(
                this.handleIntersect.bind(this),
                { threshold: this.settings.threshold }
            );

            this.elements.forEach(el => {
                this.prepare(el);
                this.observer.observe(el);
            });
        },

        prepare(el) {
            const duration = el.dataset.revealDuration || this.settings.duration;
            const easing = el.dataset.revealEasing || this.settings.easing;
            
            el.style.transition = `opacity ${duration}ms ${easing}, transform ${duration}ms ${easing}`;
            
            this.settings.onPrepare?.(el);
        },

        handleIntersect(entries) {
            entries.forEach(entry => {
                if (!entry.isIntersecting) return;

                const el = entry.target;
                const delay = parseInt(el.dataset.revealDelay) || this.settings.delay;

                this.settings.onStart?.(el);

                setTimeout(() => {
                    el.classList.add('revealed');
                    
                    const duration = parseInt(el.dataset.revealDuration) || this.settings.duration;
                    setTimeout(() => this.settings.onComplete?.(el), duration);
                }, delay);

                if (this.settings.once) {
                    this.observer.unobserve(el);
                }
            });
        },

        refresh() {
            const newElements = document.querySelectorAll('[data-reveal]:not(.reveal-prepared)');
            newElements.forEach(el => {
                this.prepare(el);
                el.classList.add('reveal-prepared');
                this.observer.observe(el);
            });
        },

        destroy() {
            this.observer?.disconnect();
            this.elements.forEach(el => {
                el.classList.remove('revealed', 'reveal-prepared');
                el.style.transition = '';
            });
        }
    };

    ScrollReveal.init({
        duration: 500,
        onStart: (el) => {},
        onComplete: (el) => {}
    });
    
    function animateHeading(selector, delay = 100, threshold = 0.5) {
        const targets = document.querySelectorAll(selector);
        if (!targets.length) return;

        // 复用单个 observer 实例
        const observerCallback = (entries, obs) => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) return;
                
                const words = entry.target.querySelectorAll('.word');
                words.forEach((word, i) => {
                    setTimeout(() => word.classList.add('in-viewport'), i * delay);
                });
                
                obs.unobserve(entry.target);
            });
        };

        const observer = new IntersectionObserver(observerCallback, { threshold });

        targets.forEach(target => {
            const ps = target.querySelectorAll('p');
            const elements = ps.length ? ps : [target];

            // 使用 DocumentFragment 批量操作 DOM
            elements.forEach(ele => {
                const split = new SplitType(ele, { types: 'lines, words, chars' });

                // 批量包裹 lines
                const fragment = document.createDocumentFragment();
                split.lines.forEach(line => {
                    const wrapper = document.createElement('div');
                    wrapper.className = 'line-wrapper';
                    wrapper.appendChild(line.cloneNode(true));
                    fragment.appendChild(wrapper);
                });

                // 一次性替换
                split.lines.forEach((line, i) => {
                    line.replaceWith(fragment.children[0]);
                });

                observer.observe(ele);
            });

            // 单次 rAF 处理所有 target
            requestAnimationFrame(() => target.classList.add('ready'));
        });
    }

    animateHeading('.animated-heading', 100, 0.5);
};


window.addEventListener('DOMContentLoaded', function() {
    HeaderModule();
    initHeaderModule();
    initSubnavModule();
    initMobileSubnavModule();
    initCommon();
});

